/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { getLifetime, Lifetime } from 'src/core/utils/lifetime';

/**
 * A simple utility wrapper around the native useEffect that wraps
 * the async effect promise into an IFE.
 *
 * @param asyncEffect The effect to fire.
 * @param deps The dependencies to re-fire the effect on.
 */
export const useAsyncEffect = <T>(asyncEffect: (lifetime: Lifetime) => Promise<T>, deps?: React.DependencyList) => {
    React.useEffect(() => {
        const lifetime = getLifetime();

        (async () => await asyncEffect(lifetime))();

        return () => lifetime.dispose();
    }, deps);
};
